import { api } from './client'

export type ClientErrorSource = 'client_js' | 'client_network'

export interface ClientErrorReport {
  message: string
  source: ClientErrorSource
  url?: string
  method?: string
  status?: number
  stack?: string
}

const sentAt = new Map<string, number>()
let sessionCount = 0
const maxPerSession = 20
const throttleMs = 60_000

/** Отправляет клиентскую ошибку. Ошибки самой отправки глотаются. */
export function reportClientError(report: ClientErrorReport): void {
  if (sessionCount >= maxPerSession) return
  const key = `${report.method || ''}|${report.url || ''}|${report.status || 0}`
  const now = Date.now()
  const prev = sentAt.get(key) ?? 0
  if (now - prev < throttleMs) return
  sentAt.set(key, now)
  sessionCount++
  const body = {
    message: report.message.slice(0, 4000),
    source: report.source,
    url: (report.url || '').slice(0, 512),
    method: report.method || '',
    status: report.status || 0,
    stack: (report.stack || '').slice(0, 4000),
  }
  void api
    .post('/api/user/client-errors', body, {
      skipAuthRedirect: true,
    } as import('axios').AxiosRequestConfig & { skipAuthRedirect?: boolean })
    .catch(() => {})
}
